const HeadToHeadTeamScore = ({ type, score }) => {
  return (
    <div className="si-league__headToHeadTeamScore">
      <div
        className={`si-league__headToHeadTeamScore-type si-league__headToHeadTeamScore-type--${type}`}
      >
        <span className="si-league__headToHeadTeamScore-type-text">{type}</span>
      </div>
      <div className="si-league__headToHeadTeamScore-score">
        {String(score).padStart(2, "0")}
      </div>
    </div>
  );
};

export default HeadToHeadTeamScore;
